<script lang="ts">
  import { debounce } from "lodash";
  import type { IntegrationDetails, MarketManAuthInfo } from "../../helpers/types";
  import { track } from "../../helpers/mixpanel";
  import { selectedBuyer } from "../../stores/buyer";
  export let integration: IntegrationDetails;
  export let onAuthSubmit = (mmAuth: MarketManAuthInfo) => {};

  let buyerGuidInput: HTMLInputElement;
  let hqBuyerGuidInput: HTMLInputElement;

  let mmAuth: MarketManAuthInfo;

  const token = integration?.token ? JSON.parse(integration.token) : "";

  const onSubmit = () => {
    mmAuth = {
      buyer_guid: buyerGuidInput.value,
      hq_buyer_guid: hqBuyerGuidInput.value,
      setup_token: integration.setup_token,
    };

    onAuthSubmit(mmAuth);
  };

  const contactUsClick = function () {
    track("integration_tevalis_contact_us_click", {
      buyer_id: $selectedBuyer?.id,
      buyer_name: $selectedBuyer?.name,
      integration_id: integration.id,
      platform: integration.platform,
      external_site_id: integration.site_id,
    });
  };

  const handleFieldUpdate = debounce((e) => {
    // const email = e.target.value;
    // const isValid = addressInput.checkValidity();
    // //validationFailed = !isValid;
    // isValid && saveNotificationEmail(email, integration.id);
    // console.log(isValid, "email", email);
  }, 300);

  // console.log("isConnected", isConnected);

  // http: const onConnectTevalis = () => {};
</script>

<div class="container">
  <div class="mm_input_container">
    <p>
      Buyer GUID and HQ GUID available with MarketMan
      <a on:click={contactUsClick} href="mailto:rekki@marketman.com">rekki@marketman.com</a>
    </p>
    <input
      placeholder="Buyer GUID"
      bind:this={buyerGuidInput}
      on:input={handleFieldUpdate}
      class="auth-input"
      type="text"
      value={token?.buyer_guid || ""}
    />
    <input
      placeholder="HQ Buyer GUID (only needed in case of a chain)"
      bind:this={hqBuyerGuidInput}
      on:input={handleFieldUpdate}
      class="auth-input"
      type="text"
      value={token?.hq_buyer_guid || ""}
    />
  </div>
  <button class="contact-us-btn" on:click={() => onSubmit()}
    >connect to {integration.platform}</button
  >
</div>

<style>
  .container {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .mm_input_container {
    display: flex;
    flex-direction: column;
  }

  .auth-input {
    background-color: var(--rekki-neutral-01);
    height: 60px;
    border-radius: 8px;
    border: none;
    font-size: 18px;
    padding: 0 12px;
    margin-bottom: 8px;
  }

  .contact-us-btn {
    border-radius: 100px;
    padding: 10px 20px;
    background-color: var(--rekki-accent);
    color: var(--rekki-light);
    border: none;
    justify-self: flex-end;
    font-family: "REKKI-OCD";
    white-space: nowrap;
    text-transform: uppercase;
    margin-left: auto;
    font-size: 16px;
  }
</style>
